import { render } from "./DeleteLegacyFlow.vue?vue&type=template&id=1bfcd511"
import script from "./DeleteLegacyFlow.vue?vue&type=script&lang=js"
export * from "./DeleteLegacyFlow.vue?vue&type=script&lang=js"
script.render = render

export default script